<template>
  <li>
    <router-link :to="{ name: 'placements.single', params: { placementId: placement.id }}">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 col-lg-3">
          <p class="strong">Placement {{ placement.number }}</p>
        </div>
        <div class="col-12 col-sm-8 col-lg-5">
          <p>{{ placement.agency ? placement.agency.name : 'Undefined' }}</p>
        </div>
        <div class="col-12 col-sm-12 col-lg-4 text-lg-right">
          <p class="text-muted">
            <span class="data-label d-lg-none">Placement Dates:</span>
            {{ placement.start_date | date }} to {{ placement.end_date | date }}
          </p>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    placement: {
      required: true,
      type: Object
    }
  }
}
</script>
